import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Hook to use Telegram's native BackButton
 * Shows the back button and navigates back in history when clicked
 * Automatically hides the button when the component unmounts
 */
export function useTelegramBackButton() {
  const navigate = useNavigate();

  useEffect(() => {
    const webApp = window.Telegram?.WebApp;
    if (!webApp?.BackButton) return;

    const handleBack = () => {
      // Use browser history to go back, just like a real back button
      navigate(-1);
    };

    // Small delay to ensure proper state after navigation
    // This fixes iOS timing issues where the button briefly shows correctly
    // then resets due to React effect ordering
    const timeoutId = setTimeout(() => {
      webApp.BackButton.show();
    }, 50);

    webApp.BackButton.onClick(handleBack);

    // Cleanup: hide button and remove handler
    return () => {
      clearTimeout(timeoutId);
      webApp.BackButton.offClick(handleBack);
      // Don't hide on cleanup - let the next page control visibility
      // This prevents the flash of incorrect state during transitions
    };
  }, [navigate]);
}

export default useTelegramBackButton;
